import * as yup from 'yup';

export const validationSchema = yup.object({
    paymentDate: yup.date().typeError("Must be a valid date").required("Required"),
    amount: yup.number().typeError("Must be a valid number").required("Required"),
    paymentMethod: yup.string().required("Required (ex. Cash/Card/etc)"),
    transactionId: yup.string().typeError("asd").required("Required")
})